export enum SessionStorageKeys {
  REQUESTED_OKTA_SCOPE = 'requested-okta-scope',
  OKTA_CODE_VERIFIER = 'ndp-ocv',
  POST_LOGIN_REDIRECT = 'post-login-redirect',
  OKTA_STATE_TOKEN = 'okta-state-token',
  MFA_REDIRECTING = 'mfa-redirecting',
}

export function storeOnSessionAndRedirect(obj, redirectMiddleware?: (redirectUrl: string) => string) {
  Object.keys(obj).forEach((key) => {
    sessionStorage.setItem(key, obj[key]);
  });

  const redirectUrl = window.location.origin + window.location.pathname;

  window.location.replace(redirectMiddleware ? redirectMiddleware(redirectUrl) : redirectUrl);
}